import React from 'react';
import { SmallSmallPolicy } from './policyData';

function renderValueByKey(key, value) {
  if (Array.isArray(value)) {
    if (key === 'faqs') {
      return (
        <ul className="space-y-3">
          {value.map(({ q, a }, i) => (
            <li key={i}>
              <p className="font-semibold">{q}</p>
              <p className="text-gray-700">{a}</p>
            </li>
          ))}
        </ul>
      );
    }
    if (key === 'platforms') {
      return (
        <ul className="list-disc ml-6 space-y-1">
          {value.map(({ name, rule }, i) => (
            <li key={i}>
              <span className="font-semibold">{name}:</span> {rule}
            </li>
          ))}
        </ul>
      );
    }
    if (key === 'steps') {
      return value.map((s, i) => (
        <div key={i} className="mb-4">
          <h3 className="font-semibold">{s.step}</h3>
          <ul className="list-disc ml-6">
            {s.details.map((d, j) => (
              <li key={j}>{d}</li>
            ))}
          </ul>
        </div>
      ));
    }

    return (
      <ul className="list-disc ml-6 space-y-1">
        {value.map((v, i) =>
          typeof v === 'string' ? (
            <li key={i}>{v}</li>
          ) : v.term && v.definition ? (
            <li key={i}>
              <span className="font-semibold">{v.term}:</span> {v.definition}
            </li>
          ) : (
            <li key={i}>{JSON.stringify(v)}</li>
          )
        )}
      </ul>
    );
  }

  if (value && typeof value === 'object') {
    if (key === 'contact') {
      return (
        <div>
          <p>
            <span className="font-semibold">Email:</span>{' '}
            <a
              className="text-blue-600 underline"
              href={`mailto:${value.email}`}
            >
              {value.email}
            </a>
          </p>
          {value.note && <p className="text-gray-700">{value.note}</p>}
        </div>
      );
    }

    return (
      <pre className="bg-gray-50 p-3 rounded">
        {JSON.stringify(value, null, 2)}
      </pre>
    );
  }

  return <p>{String(value)}</p>;
}

export default function RefundsAndReturnPolicy() {
  // Manually assign IDs that match your sidebar links
  const sectionIds = [
    'purpose-and-scope',
    'definitions',
    'eligibility-for-returns',
    'notification-timeline',
    'responsibility-for-defective-or-damaged-items',
    'return-process',
    'refunds-and-replacements',
    'exceptions',
    'platform-specific-rules',
    'legal-provisions',
    'frequently-asked-questions-faq',
    'contact-information',
  ];

  return (
    <section className="max-w-4xl mx-auto py-6 scroll-smooth">
      {SmallSmallPolicy.map((item, index) => (
        <section
          key={index}
          id={sectionIds[index]} // attach matching id for sidebar link
          className="mb-12 scroll-mt-24"
        >
          <h2 className="text-2xl font-semibold mb-3">{item.section}</h2>

          {Object.entries(item)
            .filter(([k]) => k !== 'section')
            .map(([key, value]) => (
              <div key={key} className="mb-4">
                {[
                  'purpose',
                  'appliesTo',
                  'terms',
                  'conditions',
                  'requirements',
                  'nonReturnable',
                  'details',
                  'vendorLiability',
                  'deliveryLiability',
                  'buyerResponsibility',
                  'steps',
                  'rules',
                  'declinedRefunds',
                  'exceptions',
                  'platforms',
                  'provisions',
                  'faqs',
                  'contact',
                ].includes(key) && (
                  <h3 className="text-lg font-medium mb-2 capitalize">
                    {key.replace(/([A-Z])/g, ' $1')}
                  </h3>
                )}
                {renderValueByKey(key, value)}
              </div>
            ))}
        </section>
      ))}
    </section>
  );
}
